import { useContext,useEffect } from "react";
import styles from "./Stage.module.css";
import { Badge, Asterisk } from "@dtpk-cc/components";

import "@dtpk-cc/components/dist/global.css";
import "@dtpk-cc/components/dist/components/Badge/Badge.css";
import "@dtpk-cc/components/dist/components/Asterisk/Asterisk.css";

import { ModalContext } from "../../contexts/ModalContext";

function Stage() {
 
 
  return (
    <div>
      <div className={styles.image_container}>
     
{  <div className={styles.test1} >
      <div className={styles.text_container}>
        <div className={styles.small_text}>Noch mehr</div>
        <div className={styles.big_text}>Highspeed</div>
        <div className={styles.small_text}>
          zum Treuepreis
        </div>
      </div>
      <div className={styles.badge}>
        <div className={styles.badge_text}>Nur Für</div>
        <div className={styles.badge_text}>ausgewählte</div>
        <div className={styles.badge_text}>Kund*innen <span><matrix-asterisk matrix-id="egBaOK"></matrix-asterisk></span></div>
      </div>
    </div> }
      
   
    { <div >
      <div className={styles.test2}>
      <div className={styles.text_container}>
        <div className={styles.small_text}>Exklusiv für Sie:</div>
        <div className={styles.big_text}>Highspeed</div>
        <div className={styles.small_text}>
          zum Treuepreis
        </div>

        <div className={styles.badge}>
          <div className={styles.badge_text}>Nur Für</div>
          <div className={styles.badge_text}>ausgewählte</div>
          <div className={styles.badge_text}>Kund*innen</div>
        </div>
      </div>
    </div>
    </div>}


      </div>
    </div>
    
  );
}

export default Stage;
